/* TEAM CARD FLIP (Touch Devices) */

export function initTeamCardFlip() {
  if (!window.matchMedia('(hover: none)').matches) return;

  document.querySelectorAll('.team-card').forEach(card => {
    card.addEventListener('click', () => {
      card.classList.toggle('flipped');
    });
  });
}


